export default __webpack_public_path__ + "static/media/Dr-Rashmi-Agarwal-img.bbb7c526.jpg";